import React, { useState } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../_metronic/layout";
import { FeedPage } from "./FeedPage";
import { HomePage } from "./HomePage";
import { ManagementPage } from "./ManagementPage";
import { VerifyPage } from "./VerifyPage";
import { SearchPage } from "./SearchPage";
import { AuditPage } from "./AuditPage";
import { GetRole } from "../../utils/AuthUtils";
import { ProtectedRoute } from "../components/protected-route/ProtectedRoute";
import dotenv from "dotenv";
dotenv.config();

export default function BasePage() {
  return (
    <>
      <Switch>
        {/* <Redirect exact from="/" to="/home" /> */}
        <ProtectedRoute
          pageRoles={process.env.REACT_APP_HOME_ROLES}
          path={"/"}
          currentComponent={HomePage}
        />
        {/* <ContentRoute path="/home" component={HomePage} /> */}
      </Switch>
      <Switch>
        <ProtectedRoute
          pageRoles={process.env.REACT_APP_FEED_ROLES}
          path={"/feed"}
          currentComponent={FeedPage}
        />
        {/* <ContentRoute path="/feed" component={FeedPage} /> */}
      </Switch>
      <Switch>
        <ProtectedRoute
          pageRoles={process.env.REACT_APP_MANAGEMENT_ROLES}
          path={"/management"}
          currentComponent={ManagementPage}
        />
        {/* <ContentRoute path="/management" component={ManagementPage} /> */}
      </Switch>
      <Switch>
        <ProtectedRoute
          pageRoles={process.env.REACT_APP_VERIFY_ROLES}
          path={"/verify"}
          currentComponent={VerifyPage}
        />
        {/* <ContentRoute path="/verify" component={VerifyPage} /> */}
      </Switch>
      <Switch>
        <ProtectedRoute
          pageRoles={process.env.REACT_APP_SEARCH_ROLES}
          path={"/search"}
          currentComponent={SearchPage}
        />
        {/* <ContentRoute path="/search" component={SearchPage} /> */}
      </Switch>
      <Switch>
        <ProtectedRoute
          pageRoles={process.env.REACT_APP_AUDIT_ROLES}
          path={"/audit"}
          currentComponent={AuditPage}
        />
        {/* <ContentRoute path="/audit" component={AuditPage} /> */}
      </Switch>
    </>
    // // <Suspense fallback={<LayoutSplashScreen/>}>
    // <Switch>
    //     {
    //         /* Redirect from root URL to /Feed. */
    //        <Redirect exact from="/" to="/Feed" /> //,
    //        // <Redirect exact from="/token" to="/token" />
    //     }

    //     <ContentRoute path="/Feed" component={FeedPage} />
    //     <ContentRoute path="/token" component={TokenPage} />

    // </Switch>
    // </Suspense>
  );
}
